/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CodeExchange.vue?vue&type=template&id=a28d872c"
import script from "./CodeExchange.vue?vue&type=script&lang=js"
export * from "./CodeExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28d872c')) {
      api.createRecord('a28d872c', component.options)
    } else {
      api.reload('a28d872c', component.options)
    }
    module.hot.accept("./CodeExchange.vue?vue&type=template&id=a28d872c", function () {
      api.rerender('a28d872c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CodeExchange.vue"
export default component.exports